











import Vue from 'vue';
import { genVuexComputeds } from '@/main/pages/editFactory';
import { formatDecimalValue } from '@/main/utils/stringHelper';

import { store } from '../store/edit';
import { apiProvider } from '../api';
import { ZAKAZKA_DRUH } from '../constants';


export default Vue.extend({
	name: 'PredbeznaCena',
	props: {
		storeUri: { type: String, default: null },
	},
	computed: {
		labelName() {
			return this.dmsSys.EnableGSTPrp ? 'WithoutGST' : 'VypocetDPH';
		},
		...genVuexComputeds(store),
		disableBtn(): boolean {
			return this.ZakazkaDruh === ZAKAZKA_DRUH.PREVOD_ND && this.isZakazkaDisabled;
		},
		formattedTotalPrice() {
			return this.CenaCelkem != null ? formatDecimalValue(this.CenaCelkem) : this.CenaCelkem;
		},
	},
	methods: {
		async calcPrice() {
			try {
				this.CenaCelkem = (await apiProvider.getPrice(this.ZakazkaId!)).data;
			} catch {
				this.CenaCelkem = 0;
			}
		},
	},
});
